<template>
  <q-dialog v-model="remove" persistent transition-show="scale" transition-hide="scale">
    <q-card style="width:320px">
      <div class="alert-box">
        <div class="alert-title">ALERT!!</div>
        <div class="alert-content">
          <div class="alert-text">Are you sure to delete report ?</div>
          <div class="alert-actions">
            <q-btn flat @click="remove=false">CANCEL</q-btn>
            <q-btn flat :loading="loading" :disable="loading" label="OK" @click="del">
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script>
import axios from "../axios";
export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async del() {
      try {
        this.loading = true;
        await axios.delete(`tsd-analysis/${this.id}`);
        this.loading = false;
        this.$store.commit("reports/SET_REMOVE_REPORT", this.id);
        this.remove = false;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    id() {
      return this.$store.state.reports.selectedReportForRemove;
    },
    remove: {
      get() {
        return this.$store.state.reports.remove;
      },
      set(val) {
        this.$store.commit("reports/SET_REMOVE", val);
      },
    },
  },
};
</script>
